import React, { useEffect } from 'react';
import './footer-fixed-bottom.scss';

//export default function FooterFixedBottom({ datalink }) {
export default function FooterFixedBottom({ uri, componentArray }) {

  useEffect(() => {
    //console.log(componentArray)
  }, []);

  return (
    <table className="footer fixed-bottom my-footer-fixb text-center">
      <tbody>
        <tr className="align-middle">
          {componentArray.map((component, index) => (
            <td key={index} className="align-middle border border-1 border-top-0 border-bottom-0"
              style={{ minWidth: "100px" }}>
              <>
                {component}
              </>
            </td>
          ))}
        </tr>
      </tbody>
    </table >
  );


}
